import type { TierActionType } from '@app/domains/champion/types';

type ChampionActionStateReturn = {
    activating: boolean;
    cancelling: boolean;
};

export const championActionState = (actionType: TierActionType): ChampionActionStateReturn => {
    const cancelling = ['unsubscribe', 'reactivate'].includes(actionType);
    const activating = !cancelling;

    return {
        activating,
        cancelling,
    };
};
